import {timeAgo} from 'src/app/domain/util/timestamps/timestamps';

export const toGatewayMessage = (status: string | undefined, instant: string) => {
  if (status == "OFFLINE") {
    return `Offline since: ${timeAgo(new Date(instant))}`
  } else if (status == "ONLINE") {
    return `Online since: ${timeAgo(new Date(instant))}`
  }
  return "Status unknown";
}

export const toGatewayColorClass = (status?: string) => {
  if (status === "ONLINE") return "color-primary-information";
  return "color-danger";
}
